export const global = {
  tareas: {enElaboracion:-1,recibido:25,enviado:25,tareaRecibida:25,tareaEnviada:25}
};
